<template>
  <div>
    <footer class="footer-light mt-5" style="margin-bottom: 0px !important;">
      <section class="section-b-space light-layout mobile-section">
        <div class="container">
          <div class="row footer-theme partition-f">
            <div class="footer-contant">
              <div class="row">
<!--                <div class="footer-logo col-xs-6">-->
<!--                  <img class="footer-logo-size" :src='"@/assets/images/icon/logo-footer.png"' alt="logo" />-->
<!--                </div>-->
                <div class="footer-social col-xs-6">
                  <ul>
<!--                    <li>-->
<!--                      <a href="#">-->
<!--                        <i class="fa fa-facebook" aria-hidden="true"></i>-->
<!--                      </a>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                      <a href="#">-->
<!--                        <i class="fa fa-google-plus" aria-hidden="true"></i>-->
<!--                      </a>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                      <a href="#">-->
<!--                        <i class="fa fa-twitter" aria-hidden="true"></i>-->
<!--                      </a>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                      <a href="#">-->
<!--                        <i class="fa fa-instagram" aria-hidden="true"></i>-->
<!--                      </a>-->
<!--                    </li>-->
                  </ul>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="sub-title">
                <div class="footer-contant">
                  <ul class="contact-list">
                    <li>
                      (818) 836-0342
                    </li>
                    <li>
                      Adult-Use Retail: C10-0000496-LIC
                    </li>
                    <li>
                      <i class="fa fa-copyright" aria-hidden="true"></i>2022 Unibud. All Right Reserved.
                    </li>                    
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  <TapTop/>
  </div>
</template>

<script>
import TapTop from '../widgets/tap-to-top'
export default {
  data() {
    return {
      // result_debit: null,

    }
  },
  components: {
    TapTop
  },
  created() {
  }
}
</script>
<style scoped>
  @font-face {
    font-family: "Helvetica";
    src: local("Helvetica"),
    url('../../assets/fonts/Helvetica.ttf') format("truetype");
  }
  .footer-theme .sub-title .contact-list li{
    font-family: "Helvetica";
  }
</style>
